import { IContactHistory } from '@blcloud/bl-datamodel';
// -----------------------------------------------------------------------------------------
// interface
// -----------------------------------------------------------------------------------------

/**
 * 実施件数
 */
export interface IStatusCount {
  /** 未実施 */
  notImplemented: number;
  /** 実施済 */
  implemented: number;
}

/**
 * 予定履歴
 */
export interface IScheduleHistory {
  /** 識別キー */
  key?: string;

  /** 履歴フラグ */
  isHistory?: boolean;

  /** 商品サービスカラー */
  itemServiceColor?: string;

  /** 日時 */
  dateTime?: string;

  /** 時刻表示フラグ */
  showTimeFlg?: boolean;

  /** 実施担当 */
  executeEmployeeName?: string;

  /** 実施内容 */
  executeItem?: string;

  /** 実施結果 */
  executeResult?: string;

  /** 失注理由 */
  lostReason?: string;

  /** コメント */
  contactComment?: string;

  /** コンタクト履歴 */
  contactHistory?: IContactHistory;
}

/**
 * コンタクト関連情報
 */
 export interface IRelatedContact {
  /** 仮ID */
  tempId: number;

  /** 対象車両管理番号 */
  targetVehicleMgtNumber: number;

  /** 予定履歴リスト */
  scheduleHistoryList: IScheduleHistory[];
}

// -----------------------------------------------------------------------------------------
// enum
// -----------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------
// const
// -----------------------------------------------------------------------------------------
/**
 * 定数定義
 */
export const DEFINE = {
  /** ラベル */
  LABEL: {
    /** 実施済 */
    IMPLEMENTED: '実施済',
    /** 作業中 */
    WORKING: '作業中',
    /** 未実施 */
    NOT_IMPLEMENTED: '未実施'
  },
  /** 入力検証キー */
  RULE_KEY: {
    /** コンタクト実施結果コード */
    EXECUTE_RESULT_CODE: 'ContactHistory#contactExecuteResultCode',
    /** コンタクト失注理由コード */
    LOST_REASON_CODE: 'ContactHistory#contactLostReasonCode',
    /** コンタクトコメント */
    COMMENT: 'ContactHistory#contactComment',
    /** 再コンタクト従業員名称 */
    RE_EMPLOYEE_NAME: 'Contact#reContactEmployeeName',
    /** 再コンタクト実施予定日時 */
    RE_SCHEDULE_DATE: 'Contact#reContactImplScheduleDate'
  },

  /** 実施区分(実施済み) */
  EXECUTE_DIV_IMPLEMENTED: 2
};

/**
 * メッセージ定義
 */
export const MESSAGE = {
  /** 伝票発行選択 */
  INFO_SELECT_SLIP_PRODUCT: '伝票を作成する業務を選択してください。',
  /** コンタクト結果保存確認 */
  CONFIRM_SAVE_CONTACT_RESULT: 'コンタクト結果を登録します。\nよろしいですか？',
  /** メモ上書き確認 */
  CONFIRM_OVERWRITE_MEMO: '選択した定型文でメモ本文を上書きします。\nよろしいですか？'
};

/**
 * コンタクト実施結果
 */
export const CONTACT_RESULT_CODE = {
  /** 受付 */
  RECEPTION: 95002,
  /** 伝票発行 */
  SLIP_ISSUE: 95003
};



// WEBPACK FOOTER //
// ./src/app/page/call-list-page/result-form-modal/result-form-modal.interface.ts